import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, InfiniteScroll, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { BsArrowRepeat } from '@react-icons/all-files/bs/BsArrowRepeat';
import { AppStore } from '../Core/AppStore';
import { DisplayHeader } from '../Displays/DisplayHeader';
import { DisplayRow } from '../Displays/DisplayRow';
import { DisplayFilter } from './DisplayFilter';
import { DisplayListViewModel } from './DisplayListViewModel';

export interface IDisplaySelectorCardProps {
    readonly vm: DisplayListViewModel;
    readonly history: any;
}

@autoinject
@observer
export class DisplaySelectorCard extends React.Component<IDisplaySelectorCardProps> {
    public render() {
        const { hasMore, busy, loadMoreAsync, displays, total } = this.props.vm;

        return (
            <div className="card">
                <div className="card-header bg-btn-primary d-flex">
                    <div>Displays {total > 0 ? total : ''}</div>
                </div>
                <div
                    className="card-body p-0"
                    ref={this.setDisplayListContainer}
                    style={{ overflowY: 'scroll', height: 800 }}
                >
                    <div>
                        <div className="card-display-filter">
                            <DisplayFilter vm={this.props.vm} isInForm inputClass="border-0" />
                        </div>

                        <InfiniteScroll
                            throttle={100}
                            threshold={300}
                            hasMore={hasMore}
                            isLoading={busy}
                            container={this.displayListContainer}
                            onLoadMore={loadMoreAsync}
                        >
                            <table className="table table-striped">
                                <DisplayHeader
                                    vm={this.props.vm}
                                    whitelist={[{ option: 'Serial Number' }, { option: 'Unit Serial Number' }]}
                                />

                                <tbody>
                                    {!busy && (!displays || !displays.length) && (
                                        <tr>
                                            <td colSpan={4} className="text-center">
                                                No Results
                                            </td>
                                        </tr>
                                    )}
                                    {displays.map(d => (
                                        <DisplayRow
                                            key={d.serialNumber}
                                            display={d}
                                            whitelist={[{ option: 'Serial Number' }, { option: 'Unit Serial Number' }]}
                                            vm={this.props.vm}
                                            history={this.props.history}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </InfiniteScroll>
                        {busy && (
                            <div className="w-100 text-center">
                                <BsArrowRepeat />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    @bind
    @action
    private setDisplayListContainer(r: HTMLDivElement | null) {
        this.displayListContainer = r;
    }

    @observable
    @inject
    public readonly appStore!: AppStore;

    private displayListContainer: HTMLDivElement | null = null;
}
